import Head from 'next/head'
import Script from 'next/script'
import Image from 'next/image';
import { getPostBySlug, getWpNewPostsByCategory, getWpPostsByCategory } from '../../../lib/service';
import { s3Static } from '../../../utils/constants';
import { BlogHeaderLinks } from '../../../components/blogs/BlogHeaderLinks';
import { BlogsList } from '../../../components/blogs/BlogList';
import { blogsMaster } from '../../../utils/sg-blogs-data';
import { getWpHvacServices, getWpNewHouseKeeping, getWpNewHvacServices, setWpHvacServices, setWpNewHouseKeeping, setWpNewHvacServices } from '../../../service/wp-blogs-store';
import { getRequestJSON } from '../../../api/index/location-api';
import { PartTimeHelperRequestForm } from '../../../components/index/service-category/domestic-service/PartTimeHelperRequestForm';
import Link from 'next/link';
import { PartTimeHelperRequestFormSlug } from '@/index/service-category/domestic-service/PartTimeHelperRequestFormSlug';
import { helperCostCalculation } from 'js/part-time-helper-cost';
import { getBabySitterSlugData, getCookSlugData, getElderlyCareSlugData, getHelperSlugData, setBabySitterSlugData, setCookSlugData, setElderlyCareSlugData, setHelperSlugData } from 'service/page-slug-store';

export const getStaticPaths = async () => {
    const posts = await getWpNewPostsByCategory(100, "house-keeping");
    const oldPosts = await getWpPostsByCategory(100, "house-keeping");
    posts.push(...oldPosts)

    return {
      paths: posts.map((post) => `/sg/part-time-cleaner-singapore/${post.slug}`),
      fallback: false,
    };
};
  
export const getStaticProps = async ({ params }) => {
    const countryCd = "sg"
    const countryName = "Singapore"  

    const post = await getPostBySlug(params?.slug);

    const blogs = blogsMaster['house-keeping'].blogArray;
    const wpNewPosts = getWpNewHouseKeeping().length > 0 ?  getWpNewHouseKeeping() : await getWpNewPostsByCategory(6, "house-keeping");
    setWpNewHouseKeeping(wpNewPosts)

    const allRequestCategorySettings = await getRequestJSON("Singapore")
    const requestCategorySettings = allRequestCategorySettings.filter(category => category.requestType === "Domestic Services")

    const currencyCd = "SGD"
    
    let helperService = []
    let babySitterService = []
    let elderlyCareService = []
    let cookingAssistanceService = []    
      
    if(getHelperSlugData().length > 0 && getBabySitterSlugData().length > 0 && getElderlyCareSlugData().length > 0 && getCookSlugData().length > 0){
          helperService = getHelperSlugData()
          babySitterService = getBabySitterSlugData()
          elderlyCareService = getElderlyCareSlugData()
          cookingAssistanceService = getCookSlugData()
      } else {
          helperCostCalculation(currencyCd, helperService, babySitterService, elderlyCareService, cookingAssistanceService)
          setHelperSlugData(helperService)
          setBabySitterSlugData(babySitterService)
          setElderlyCareSlugData(elderlyCareService)
          setCookSlugData(cookingAssistanceService)  
      }
    

    return {
      props: { 
        post,
        blogs,
        wpNewPosts,
        requestCategorySettings,
        helperService,
        babySitterService,
        elderlyCareService,
        cookingAssistanceService,
        countryCd,
        countryName
      },
      // Next.js will attempt to re-generate the page:
      // - When a request comes in
      // - At most once every 3 days
      revalidate: 259200, // In seconds
    };
};

export default function Home(props) {
  const post = props.post
  const description = post.excerpt.replace(/<[^>]+>/g, '').trim()

  const blogs = props.blogs
  const wpNewPosts = props.wpNewPosts

  const requestCategorySettings = props.requestCategorySettings
  const { 
      helperService,
      babySitterService,
      elderlyCareService,
      cookingAssistanceService,
      countryCd,
      countryName 
  } = props

  return (
    <>
      <Head>
        <title>{post.title}</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="description" content={description}/>
        <meta name="keywords" content="Maid Service, Home Cleaning, Part-time Maids, Part-time helper, part-time cleaner"/>
        <meta name="author" content="StringsSG"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:url"  content={`https://www.stringssg.com/sg/part-time-cleaner-singapore/${post.slug}`} />
        <meta property="og:type"   content="article" />
        <meta property="og:title"    content={post.title}/>
        <meta property="og:description" content={description} />
        <meta property="article:publisher" content="https://www.facebook.com/StringsSG/" />
        <meta property="article:published_time" content={post.date} />
        <meta property="article:modified_time" content={post.modified} />
        <meta property="og:image"  content={post?.featuredImage?.node?.sourceUrl} />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content={post?.featuredImage?.node?.sourceUrl} />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content={`https://www.stringssg.com/sg/part-time-cleaner-singapore/${post.slug}`}/>
        <meta name="twitter:title" content={post.title}/> 
        <meta name="twitter:description" content={description}/>
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href={`https://www.stringssg.com/sg/part-time-cleaner-singapore/${post.slug}`} />
        <script type="application/ld+json"
          dangerouslySetInnerHTML={{ __html:
            `{"@context":"https://schema.org","@graph":[{"@context":"https://schema.org/","@type":"BlogPosting","mainEntityOfPage":{"@type":"WebPage","@id":"${`https://www.stringssg.com/sg/part-time-cleaner-singapore/${post.slug}`}"},"headline":"${post.title}","description": "${description}","image":["${post?.featuredImage?.node?.sourceUrl}"],"author":{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG","url":"https://www.stringssg.com/"},"publisher":{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG","url":"https://www.stringssg.com/","logo":{"@type":"ImageObject","url":"https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/logo.png"}},"datePublished":"${post.date}","dateModified":"${post.modified}"},{"@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"helper-singapore","item":"https://www.stringssg.com/sg/part-time-cleaner-singapore"},{"@type":"ListItem","position":2,"name":"${post.slug}"}]}]}`
          }}
        />
      </Head>
      <div>
        <PartTimeHelperRequestFormSlug requestCategorySettings={requestCategorySettings} post={post} 
        helperService={helperService} babySitterService={babySitterService} elderlyCareService={elderlyCareService} cookingAssistanceService={cookingAssistanceService}
        countryCd={countryCd} countryName={countryName}/>
        <section className="py-10 space-y-10">
            <div className='max-w-5xl mx-auto px-2 space-y-10'>
              <h1 className="text-2xl md:text-3xl text-center font-bold">{post.title}</h1>
              <div
                  className="post-content w-full px-2 mx-auto space-y-5 leading-8"
                  dangerouslySetInnerHTML={{ __html: post.content }}
                  ></div>
            </div>
            <div className='text-center relative'>
                <div className='relative w-full h-80'>
                    <Image
                        src={s3Static + "blog/living/part-time-helper/female-part-time-helper.png"}
                        fill
                        style={{objectFit: 'cover', objectPosition: 'top'}}   
                        placeholder='blur'
                        blurDataURL={s3Static + "placeholder.png"}
                        alt='Part-time maid for home cleaning - StringsSG'
                    />     
                </div> 
                <div className='absolute flex items-center text-white top-0 bottom-0 left-0 right-0 w-fit mx-auto'>
                    <Link href="/sg/part-time-cleaner-singapore" prefetch={false} className='py-4 px-6 rounded-full bg-black/60 text-xl md:text-2xl'>
                          Book Part-Time Helper
                    </Link>       
                </div>  
            </div>
        </section>
        <BlogsList blogs={blogs} wpNewPosts={wpNewPosts}/>
        <div className='bg-gray-800 text-white py-4 p-2 text-center text-2xl'>
            Topics
        </div>
        <BlogHeaderLinks/>
      </div>
      <Script 
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {              
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'G-QD1HGGHDYJ');
          }} 
      />
      <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
					  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
					  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
					  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
					  n.queue=[];t=b.createElement(e);t.async=!0;
					  t.src=v;s=b.getElementsByTagName(e)[0];
					  s.parentNode.insertBefore(t,s)}(window, document,'script',
					  'https://connect.facebook.net/en_US/fbevents.js');
					  fbq('init', '128634041116395');
					  fbq('track', 'PageView');`}
        </Script>
    </>
  )
}